export default __webpack_public_path__ + "static/media/slider10.4346999a.jpg";